import type { PortfolioListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import type { RetirementPortfolioItem } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { getRetirementPortfolioEndYear } from "web_myplann/Inspiration/Retirement/Utils/getRetirementPortfolioEndYear";
import { getRetirementPortfolioItemKind } from "web_myplann/Inspiration/Retirement/Utils/getRetirementPortfolioItemKind";
import { isRetirementRelevantPortfolioItem } from "web_myplann/Inspiration/Retirement/Utils/isRetirementRelevantPortfolioItem";
import { getMonthlyPayment } from "web_myplann/Shared/Utils/getMonthlyPayment";

export const mapRetirementPortfolioItem = (
	item: PortfolioListItemResponseDTO,
): RetirementPortfolioItem | undefined => {
	if (!isRetirementRelevantPortfolioItem(item)) return undefined;
	const kind = getRetirementPortfolioItemKind(item.domain);
	const monthlyPayment = getMonthlyPayment(
		kind === "loan" ? item.installment : item.payment,
		item.paymentFrequency,
	);

	return {
		id: item.id,
		name: item.name ?? item.product ?? "",
		kind,
		monthlyPayment: Math.max(Math.round(monthlyPayment ?? 0), 0),
		endYear: getRetirementPortfolioEndYear(item.endAt),
	};
};
